import React, { useState, useEffect } from 'react';
import './Navigation.css';
import logo from './assets/logo.png';
function Navigation() {
  const [showMenu, setShowMenu] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <nav>
      <a href="/" className="brand">
        {/* Inline SVG logo — replace with <img src={logo} /> if you have a PNG */}
        {/* <svg className="brand-logo" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="48" height="48" rx="10" fill="#4fc3a1"/>
          <path d="M24 8L14 14v10c0 7.18 4.27 13.9 10 16.93C29.73 37.9 34 31.18 34 24V14L24 8z"
            fill="#fff" opacity="0.9"/>
          <path d="M20 24l3 3 6-6" stroke="#1a2b4a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        */}
        
        <img src={logo}  className="brand-logo"/>
        
        <span className="brand-name">Compliance<span>Genie</span></span>
      </a>

      {isSmallScreen && (
        <button className="menu-toggle" onClick={toggleMenu}>
          ☰
        </button>
      )}

      <ul className={`nav-list ${isSmallScreen && showMenu ? 'active' : ''}`}>
        <li><a href="/home">Home</a></li>
        <li><a href="/contactus">Contact Us</a></li>
        <li><a href="https://portal.compliancegenie.cloudservesystems.com/signup/auditee/" target="_blank" rel="noreferrer" className="signup-btn">Sign Up</a></li>
      </ul>
    </nav>
  );
}

export default Navigation;
